import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14eaab04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anim-container" }
const _hoisted_2 = { class: "anim" }
const _hoisted_3 = {
  key: 0,
  class: "percentage"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "percentage-sign" }, "%", -1))
const _hoisted_5 = { class: "status" }
const _hoisted_6 = {
  key: 0,
  class: "complement"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Nous avons bien réceptionné vos fichiers ! ")
const _hoisted_8 = {
  key: 1,
  class: "complement"
}
const _hoisted_9 = { class: "remaining_time" }

import router from "@/router";
import store from "@/store";
import {
  computed,
  onBeforeMount,
  onMounted,
  Ref,
  watch,
} from "@vue/runtime-core";
import {
  formatDurationFromSeconds,
  formatSize,
  go_back_home,
} from "@/compositions/functions";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadingView',
  setup(__props) {

onBeforeMount(() => {
  if (store.state.uploading == false) {
    router.replace("/");
  }
});

const status = computed(() => {
  if (store.state.uploaded) {
    // store.state.uploaded = false;
    // store.state.upload_percentage = 0;
    return "Vous avez terminé !";
  }
  if (store.state.upload_percentage === 0) {
    return "Nous préparons votre transfert...";
  } else if (store.state.upload_percentage < 100) {
    return "Transfert en cours...";
  } else {
    return "Finalisation...";
  }
});

const circle = ref() as Ref<HTMLDivElement>;

const uploaded = computed(() => {
  return store.state.uploaded;
});

watch(uploaded, () => {
  if (uploaded) {
    // const timeout = setTimeout(() => {
    //   store.commit("reset_state");
    //   router.replace("/");
    // }, 3000);
    circle.value.classList.add("uploaded");
  }
});

const uploading = computed(() => {
  return store.state.upload_percentage > 0;
});

const deg = computed(() => {
  return store.state.upload_percentage * 3.6;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "circle",
        ref: circle,
        class: "circle"
      }, [
        (!_unref(uploaded))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(_unref(store).state.upload_percentage), 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(status)), 1),
    (_unref(uploaded))
      ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("b", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(go_back_home)()))
          }, " Un autre fichier ? Retourner au menu ")
        ]))
      : (_openBlock(), _createElementBlock("h2", _hoisted_8, [
          _createTextVNode(_toDisplayString(_unref(formatSize)(
          (_unref(store).state.upload_percentage * _unref(store).state.upload_size) / 100
        )) + " de " + _toDisplayString(_unref(formatSize)(_unref(store).state.upload_size)) + " téléchargé ", 1),
          _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(store).state.remaining_time == Infinity
            ? "Calcul en cours..."
            : "Il reste " +
              _unref(formatDurationFromSeconds)(Math.ceil(_unref(store).state.remaining_time))), 1)
        ]))
  ]))
}
}

})